import { render, staticRenderFns } from "./ResumeLink.vue?vue&type=template&id=79a8cc07&scoped=true&"
import script from "./ResumeLink.vue?vue&type=script&lang=js&"
export * from "./ResumeLink.vue?vue&type=script&lang=js&"
import style0 from "./ResumeLink.vue?vue&type=style&index=0&id=79a8cc07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a8cc07",
  null
  
)

export default component.exports